import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("mp_admin_token") || ""}` },
});

export const downloadCsv = async (path, filename) => {
  const res = await api.get(path, { ...authHeaders(), responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

// Chunked upload (4 MB chunks bypass proxy body limits) -> object storage. Returns { id, url, ... }.
export const uploadFile = async (file, onProgress) => {
  const { data: init } = await api.post("/admin/uploads/init", { filename: file.name, size: file.size }, authHeaders());
  const chunkSize = init.chunk_size;
  const total = Math.max(1, Math.ceil(file.size / chunkSize));
  const token = localStorage.getItem("mp_admin_token") || "";
  let loaded = 0;
  for (let i = 0; i < total; i++) {
    const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);
    await api.post(`/admin/uploads/${init.upload_id}/chunk?index=${i}`, chunk, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/octet-stream" },
      onUploadProgress: (e) => onProgress?.(Math.min(99, Math.round(((loaded + (e.loaded || 0)) / file.size) * 100))),
    });
    loaded += chunk.size;
    onProgress?.(Math.round((loaded / file.size) * 100));
  }
  const { data } = await api.post(`/admin/uploads/${init.upload_id}/complete`, {}, authHeaders());
  return data;
};
